import { render, staticRenderFns } from "./SidebarIntent.vue?vue&type=template&id=520ea530&scoped=true&"
import script from "./SidebarIntent.vue?vue&type=script&lang=js&"
export * from "./SidebarIntent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarIntent.vue?vue&type=style&index=0&id=520ea530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ea530",
  null
  
)

export default component.exports